module.exports = __webpack_public_path__ + "static/img/2areaA_63.29f4045.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/2areaA_63.png
// module id = 895
// module chunks = 1